import React, { useState, useEffect } from "react";
import moment from "moment";
import Loader from "components/Loader";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import constants from "../../../../../../../constants.js";
import { encodeId, isMobileTab } from "utils";
import MoveToApp from "accountOwner/pages/Scheduler/components/Modals/MoveToApp";
import toast from "react-hot-toast";
import HolidayImage from "../../../../../../../assets/images/early_on.svg";
import styles from "../../../../Scheduler.module.scss";
import { ThreeDots } from "react-bootstrap-icons";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import SelectOfficeModal from "accountOwner/pages/Scheduler/components/Modals/SelectOfficeModal";
import {
  MoreTagsFunction,
  renderOfficeNameOrEnterprise,
} from "accountOwner/pages/AddEvent/addEvents.functions.jsx";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup.jsx";
import Empty from "components/Empty/index.js";
import { leaveClasses } from "accountOwner/pages/Scheduler/scheduler.function.js";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner/index.jsx";
import {
  splitAllDayAndTimedEvents,
  isAgendaEmptyData,
} from "./agendaView.helpers";

function AgendaDailyView(props) {
  const {
    t,
    currentDate,
    currentUserId,
    isSidebarActive,
    setCurrentDate,
    isFromDashBoard,
    setDateRange,
    agenda,
    viewSettingFilter,
    isLoading,
    isFetching,
    error,
    selectedOwnerId,
    isStaff,
    canShowOfficeName,
  } = props;
  const [isModal, setIsModal] = useState({ open: false });
  const history = useHistory();
  const { profile, effectiveOwnerIdString } = useAccountOwnerCommon();
  const [showOfficeSelectModal, setShowOfficeSelectModal] = useState(false);
  const [SelectedDateForLeave, setSelectedDateForLeave] = useState(null);
  const [hoverBusySlotKey, setHoverBusySlotKey] = useState("");
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });

  const handlePopupToggle1 = (event, hoverbusykey = "") => {
    event.stopPropagation();
    setHoverBusySlotKey(hoverbusykey);
    setInvitePopupPosition({
      top: 20,
      right: 0,
    });
  };

  const changeWeek = (type) => {
    if (type === "next") {
      setCurrentDate(moment(currentDate).add(1, "day").toDate());
    } else {
      setCurrentDate(moment(currentDate).subtract(1, "day").toDate());
    }
  };
  const isPastDate = moment(currentDate).isBefore(moment().startOf("day"));

  useEffect(() => {
    if (currentDate) {
      setDateRange({
        startDate: moment(currentDate).format("YYYY-MM-DD"),
        endDate: moment(currentDate).format("YYYY-MM-DD"),
      });
    }
    if (isMobileTab() && isSidebarActive) {
      toast.success(t("accountOwner.dateApply"));
    }
    //eslint-disable-next-line
  }, [currentDate]);

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
    //eslint-disable-next-line
  }, [error]);

  const goToDetails = (id, type, createdByMe, isInvite, requestedDate) => {
    if (!id || !type) return;
    switch (type) {
      case constants.agendaType.EVENT: {
        let pathname = "/";
        pathname = createdByMe
          ? constants.routes.scheduler.eventDetails.replace(
              ":eventId",
              encodeId(id),
            )
          : isInvite
            ? constants.routes.scheduler.eventRequestDetails.replace(
                ":eventId",
                encodeId(id),
              )
            : constants.routes.scheduler.EventWorkingDetails.replace(
                ":eventId",
                encodeId(id),
              );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        const pathname = constants.routes.scheduler.busySlotDetail.replace(
          ":busySlotId",
          encodeId(id),
        );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      default: {
        return;
      }
    }
  };

  const getUsefulInfo = (item) => {
    const id = item?.id;
    const officeName = renderOfficeNameOrEnterprise(item, t);
    let title = item?.title || item?.reasonForBlock || null;
    title =
      title && title.length > constants.agendaTitleLength
        ? title.slice(0, constants.agendaTitleLength).concat(" ...")
        : title;
    const timezoneCode = item?.timezoneCode || null;
    const isAllDayEvent = item?.isAllDayEvent;
    const timeString = item?.isAllDayEvent
      ? t("scheduler.agenda.allDayEvent")
      : moment(item?.startTime).format("h:mm A") +
        " - " +
        moment(item?.endTime).format("h:mm A");
    //sepecific to Schedular events
    const createdByMe = item.createdById === currentUserId;
    const isInvite = !!item.eventEmployeeStatus;
    const status = item.eventEmployeeStatus || item.eventRequestToJoinStatus;
    const patientName = item.patientFullName;
    const location = item?.location;
    let backgroudColorClass;
    backgroudColorClass = createdByMe
      ? ""
      : status === constants.SCHEDULERSTATUS.PENDING
        ? "color-blue"
        : "color-grey";
    return {
      officeName,
      title,
      timezoneCode,
      timeString,
      id,
      isAllDayEvent,
      createdByMe,
      isInvite,
      status,
      backgroudColorClass,
      patientName,
      location,
      isShift: item?.isShift,
    };
  };

  const getAppointmentsView = (item, index) => {
    const data = getUsefulInfo(item);
    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          styles["box-flex"] +
          " " +
          styles["light-purple-bg"]
        }
        onClick={() => {
          setIsModal({
            open: true,
            type: constants.agendaType.APPOINTMENT,
          });
        }}
      >
        <div className={styles["event-tag"] + " " + styles["dark-grey-bg"]}>
          {t("scheduler.agenda.appointmentTag")}
        </div>
        {data?.patientName && (
          <div className={styles["event-office"]}>{data?.patientName}</div>
        )}
        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) && (
          <div className={styles["event-date"]}>
            {data?.timeString}({data?.timezoneCode})
          </div>
        )}
        {canShowOfficeName &&
          (!viewSettingFilter.length ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {!viewSettingFilter.length && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) && (
          <div className={styles["event-type"]}>
            {t("scheduler.agenda.appointmentTitle")}
          </div>
        )}
      </div>
    );
  };

  const getSchedulerEventsView = (item, index, requestedDate) => {
    const data = getUsefulInfo(item);
    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          styles[data.backgroudColorClass] +
          " " +
          styles["box-flex"] +
          " cursor-pointer "
        }
        onClick={() =>
          goToDetails(
            data.id,
            constants.agendaType.EVENT,
            data.createdByMe,
            data.isInvite,
            requestedDate,
          )
        }
      >
        <div className={styles["event-tag"] + " " + styles["theme-green-bg"]}>
          {t(
            item?.isShift
              ? "scheduler.agenda.shiftTag"
              : "scheduler.agenda.eventTag",
          )}
        </div>
        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) && (
          <div className={styles["event-date"]}>
            {data?.timeString}({data?.timezoneCode})
          </div>
        )}
        {canShowOfficeName &&
          (!viewSettingFilter.length ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {!viewSettingFilter.length && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) &&
          (item?.isShift ? (
            viewSettingFilter.includes("title") && (
              <div className={styles["event-type"]}>
                {data.title?.trim()
                  ? data.title
                  : t("scheduler.agenda.shiftTag")}
              </div>
            )
          ) : (
            <div className={styles["event-type"]}> {data.title} </div>
          ))}
      </div>
    );
  };

  const getSchedulerBusySlotsView = (
    item,
    index,
    shouldRedirect,
    requestedDate,
  ) => {
    const data = getUsefulInfo(item);
    const searchKey = `${item?.id}_${requestedDate}`;
    const thisHoverKey = `${searchKey}_${index}`;
    let officeName = data?.officeName?.split(",")?.map((item) => {
      return {
        name: item,
        id: item,
      };
    });

    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          styles["light-orange-bg"] +
          " " +
          styles["box-flex"] +
          " cursor-pointer "
        }
        onClick={() => {
          if (shouldRedirect) {
            goToDetails(
              data.id,
              constants.agendaType.BUSY_SLOT,
              null,
              null,
              requestedDate,
            );
          } else {
            setIsModal({
              open: true,
              type: constants.agendaType.BLOCKED,
              officeId: item?.officeId,
            });
          }
        }}
      >
        <div className={styles["event-tag"] + " " + styles["dark-orange-bg"]}>
          {t("scheduler.agenda.busyTag")}
        </div>
        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) && (
          <div className={styles["event-date"]}>{data?.timeString}</div>
        )}
        {canShowOfficeName &&
          (!viewSettingFilter.length ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"] + " position-relative"}>
              <MoreTagsFunction
                value={officeName || []}
                lastIndex={2}
                clickHandler={(e) => handlePopupToggle1(e, thisHoverKey)}
                mapFn={(member) => `${member?.name}`}
              />
              {thisHoverKey == hoverBusySlotKey && (
                <InviteesPopup
                  position={invitePopupPosition}
                  handleInvitePopupToggle={(e) => handlePopupToggle1(e)}
                  list={officeName}
                  showRoleAndOffice={false}
                  isForEvent={true}
                  isfromBusySlot={true}
                  onlyOfffice
                />
              )}
            </div>
          )}
        {!viewSettingFilter.length && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) && (
          <div className={styles["event-type"]}> {data.title} </div>
        )}
      </div>
    );
  };

  const getLeavesView = (item, index) => {
    const data = getUsefulInfo(item);
    const { Highlighter, main, text } = leaveClasses(item?.statusId);

    return (
      <div
        key={index}
        className={
          styles["scheduler-event-box"] +
          " " +
          styles[main] +
          " " +
          styles["box-flex"]
        }
        onClick={() => {
          const isBeforeToday = moment(item?.startDate).isBefore(
            moment().startOf("day"),
          );
          if (item?.startDate && !isBeforeToday) {
            history.push({
              pathname: constants.routes.staff.editLeaves.replace(
                ":officeId",
                encodeId(item.officeId),
              ),
              state: { ...item, userId: profile.id, backRedirect: true },
            });
          } else if (isBeforeToday) {
            toast.error("You cannot edit the leaves for past dates");
          }
        }}
      >
        <div className={styles["event-tag"] + " " + styles[Highlighter]}>
          {t(text)}
        </div>
        {canShowOfficeName &&
          (!viewSettingFilter.length ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"]}>{data.officeName}</div>
          )}
        {!viewSettingFilter.length && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
      </div>
    );
  };

  let filteredAgenda = agenda;
  let tableData = null;
  let holidayRowJsx = null;

  if (filteredAgenda?.length) {
    const agendaFilter = filteredAgenda;
    tableData = filteredAgenda?.map((_item) => {
      let {
        requestedDate,
        appointments,
        leaves,
        schedulerBusySlots,
        schedulerEvents,
        appointmentSlots,
      } = _item;
      appointments = appointments || [];
      leaves = leaves || [];
      schedulerBusySlots = schedulerBusySlots || [];
      schedulerEvents = schedulerEvents || [];
      appointmentSlots = appointmentSlots || [];
      const [allDayEvents, allOtherEvents] =
        splitAllDayAndTimedEvents(schedulerEvents);
      let allItems = [
        appointments,
        schedulerBusySlots,
        allOtherEvents,
        appointmentSlots,
      ]
        .flat()
        .sort((a, b) => {
          if (
            moment(moment(b.startTime).format("HH:mm"), "HH:mm").isAfter(
              moment(moment(a.startTime).format("HH:mm"), "HH:mm"),
            )
          ) {
            return -1;
          } else {
            return 1;
          }
        });
      allItems = [...leaves, ...allDayEvents, ...allItems];
      return (
        <td
          key={requestedDate}
          style={isFromDashBoard ? { width: "100%" } : {}}
          className="border-0"
        >
          {allItems.map((item, index) => {
            const { agendaType } = item;
            switch (agendaType) {
              case constants.agendaType.EVENT: {
                return getSchedulerEventsView(item, index, requestedDate);
              }
              case constants.agendaType.BUSY_SLOT:
              case constants.agendaType.BLOCKED: {
                return getSchedulerBusySlotsView(
                  item,
                  index,
                  agendaType === constants.agendaType.BUSY_SLOT,
                  requestedDate,
                );
              }
              case constants.agendaType.APPOINTMENT: {
                return getAppointmentsView(item, index);
              }
              case constants.agendaType.LEAVE: {
                return getLeavesView(item, index);
              }
              default: {
                return null;
              }
            }
          })}
        </td>
      );
    });
    holidayRowJsx = (
      <>
        {agendaFilter.map((date, index) => {
          const adjustedIndex = index;
          const validIndex = agendaFilter[adjustedIndex];

          const holidayList = validIndex
            ? agendaFilter[adjustedIndex].holidayList
            : null;

          if (
            holidayList?.length > 0 &&
            validIndex?.requestedDate === holidayList?.[0]?.date
          ) {
            return (
              <td
                key={`holiday-${index}`}
                className={
                  styles["holiday-cell"] +
                  " border-0 p-0 w-100 d-flex justify-content-center align-items-center " +
                  styles["light-red-bg"]
                }
                style={
                  isFromDashBoard
                    ? { minWidth: "150px", maxWidth: "150px" }
                    : {}
                }
              >
                <div className={styles["holiday_title"] + " m-0"}>
                  <img
                    src={HolidayImage}
                    alt="holiday"
                    className="account_owner_image"
                  />
                  <div className={styles.holiday_title_text}>
                    {holidayList?.[0]?.title}
                  </div>
                </div>
              </td>
            );
          }
          return <td key={`holiday-${index}`} style={{ border: "none" }}></td>;
        })}
      </>
    );
  }
const dataEmpty = isAgendaEmptyData(filteredAgenda);
  return (
    <div
      className={"agenda-fixed-table table-card-border h-100"}
      style={isFromDashBoard ? { borderLeft: "none" } : {}}
    >
      {isLoading && <Loader />}
      <div
        className={
          isFromDashBoard
            ? styles["scheduler-fixed-table-new-my-schedule"]
            : styles["scheduler-fixed-table"]
        }
      >
        <table
          className={
            "table table-bordered " +
            " h-100" +
            " " +
            styles["schedular-table"] +
            " " +
            styles["daily-table"]
          }
          style={
            isFromDashBoard ? { borderLeft: "none" } : { borderTop: "none" }
          }
        >
          <thead>
            {!isFromDashBoard && (
              <tr className={styles.bg_header}>
                <th
                  className={styles.events_th}
                  style={{
                    width: "180px",
                    border: "none",
                    height: "100%",
                  }}
                >
                  <div
                    className={
                      styles.date_icon_wrap + " " + styles.border_left_none
                    }
                  >
                    <div
                      className={styles["arrow-btn"] + " " + styles["prev-btn"]}
                      onClick={() => changeWeek("prev")}
                    >
                      <img
                        src={
                          require("assets/images/scheduler-table-arrow-left.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>
                    <div className={styles.date_text}>
                      {moment(currentDate).format("ddd, MMM DD, YYYY")}
                      {!isPastDate && (
                        <UncontrolledDropdown
                          className={styles.ellipsis_position_dots_daily}
                        >
                          <DropdownToggle
                            caret={false}
                            tag="div"
                            className="cursor-pointer"
                          >
                            <div
                              className={
                                styles.ellipsis_icon + " " + `ellipsis-icon`
                              }
                            >
                              <ThreeDots />
                            </div>
                          </DropdownToggle>
                          <DropdownMenu
                            right
                            className={styles["office-dropdown-menu"]}
                          >
                            {isStaff && (
                              <DropdownItem
                                className={styles["office-dropdown-item"]}
                                onClick={() => {
                                  setShowOfficeSelectModal(true);
                                  setSelectedDateForLeave(currentDate);
                                }}
                              >
                                {t("staffLeaves.applyLeave")}
                              </DropdownItem>
                            )}
                            <DropdownItem
                              className={styles["office-dropdown-item"]}
                              onClick={() => {
                                history.push({
                                  pathname:
                                    constants.routes.scheduler.addBusySlot,
                                  state: {
                                    date: currentDate,
                                  },
                                });
                              }}
                            >
                              {t("accountOwner.addBusyslots")}
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )}
                    </div>

                    <div
                      className={styles["arrow-btn"] + " " + styles["next-btn"]}
                      onClick={() => changeWeek("next")}
                    >
                      <img
                        src={
                          require("assets/images/scheduler-table-arrow-right.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>
                  </div>
                </th>
                <th className="p-0 border-0">
                  <p className={styles.date_icon_wrap + " m-0"}></p>
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            <tr className="h-100">
              {dataEmpty ? <td></td> : holidayRowJsx}
              {dataEmpty ? (
                <td>
                  <Empty Message={t("scheduler.eventsEmptyMessage")} />
                </td>
              ) : (
                tableData
              )}

              <MoveToApp
                isModal={isModal?.open}
                openModal={setIsModal}
                type={isModal?.type}
                officeId={isModal?.officeId || null}
              />
            </tr>
          </tbody>
        </table>
      </div>
      {showOfficeSelectModal && (
        <SelectOfficeModal
          selectedOwnerId={selectedOwnerId}
          showOfficeSelectModal={showOfficeSelectModal}
          setShowOfficeSelectModal={setShowOfficeSelectModal}
          SelectedDateForLeave={SelectedDateForLeave}
        />
      )}
    </div>
  );
}

export default withTranslation()(AgendaDailyView);
